/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonStudentDataViewModel } from "../types/PersonStudentDataViewModel.ts";

export const personStudentDataViewModelSchema = z.object({
  studentId: z.optional(z.number().int().describe("ID do registro de aluno.")),
  personId: z.optional(
    z.number().int().describe("ID da pessoa associada ao aluno."),
  ),
  ra: z.string().describe("Registro Acadêmico (RA) do aluno.").nullish(),
  codeUsp: z.string().describe("Código USP atual do aluno.").nullish(),
  codeUspOld: z.string().describe("Código USP antigo do aluno.").nullish(),
  curriculum: z
    .string()
    .describe("Grade curricular associada ao aluno.")
    .nullish(),
  perfilPublic: z.optional(
    z.boolean().describe("Indica se o perfil do aluno é público."),
  ),
  isGraduateFinished: z
    .boolean()
    .describe("Indica se o aluno concluiu a graduação. Opcional.")
    .nullish(),
  graduateFinishedDate: z
    .string()
    .datetime()
    .describe("Data de conclusão da graduação do aluno. Opcional.")
    .nullish(),
}) as unknown as ToZod<PersonStudentDataViewModel>;
